export enum HublerCalendarUnavailabilityReason {
  HUBLER = 'HUBLER',
  GTA = 'GTA',
  HUBLER_AND_GTA = 'HUBLER_AND_GTA',
}
